import { EmailsSettingOutputApiModel } from "../models/api-models/output";

export interface EmailsSettingEntity {
    senderEmail: string;
    senderName: string;
    isSSL: boolean;
    smtpUsername: string;
    smtpPassword: string;
    smtpServer: string;
    smtpPort: number;
    requested_from_email?: string;
    requested_from_name?: string;
}

export class EmailsSettingEntity {
    constructor(data: EmailsSettingOutputApiModel) {
        this.senderName = data.from_name;
        this.senderEmail = data.from_email;
        this.isSSL = data.is_ssl;
        this.smtpUsername = data.smtp_username;
        this.smtpPassword = data.smtp_password;
        this.smtpServer = data.smtp_address;
        this.smtpPort = data.smtp_port;
        this.requested_from_email = data?.requested_from_email;
        this.requested_from_name = data?.requested_from_name
    }
}